import { render, staticRenderFns } from "./StepAccountManagementModal.vue?vue&type=template&id=5bffa1ac&scoped=true&"
import script from "./StepAccountManagementModal.vue?vue&type=script&lang=ts&"
export * from "./StepAccountManagementModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bffa1ac",
  null
  
)

export default component.exports